import FamilyFormInputs from '../FamilyCreateFormInput.js'
import useFormContext from "./useFormContext"
import Footer from '../Footer'
import Header from '../Header.js'
import FamilyRequestHeader from '../ResponsiveEvent.jsx/FamilyRequestHeader.js'
import { FamilyNavigation } from '../ResponsiveEvent.jsx/FamilyNavigation'
import { useEffect } from 'react';

const FamilyCreateNewRequest = () => {
    const { setFirstGet, eventFormData, page } = useFormContext()

    const initRequestedBy = () => {
        if (page == 0) {
            eventFormData.createdBy = `${localStorage.getItem('firstName')} ${localStorage.getItem('lastName')}`;
            eventFormData.requestedBy = `${localStorage.getItem('firstName')} ${localStorage.getItem('lastName')}`;
        }
    }

    useEffect(() => {
        initRequestedBy();

        setFirstGet(true);
    }, []);

    const handleSubmit = e => {
        e.preventDefault()
    }

    const content = (
        <form id="phase2RequestForm" className="form flex-col" onSubmit={handleSubmit}>
            <div>
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet"
                    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous"></link>
                <div className='container-fluid-custom'>
                    <Header />
                    <FamilyRequestHeader />
                    <div className="container-fluid">
                        <div className="row m-1 mb-5">
                            <div className="col-md-2 p-0">
                                <FamilyNavigation />
                            </div>
                            <FamilyFormInputs />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </form>
    )
    return content
}

export default FamilyCreateNewRequest